import m from "../../prime-src/prepare";
import Move from "./Move";
import Reset from "./Reset";
import Exit from "./Exit";

export default function FSMultirecoCats() {
  return (
    <div id="multireco-cats-container" className="fs-container" style={{display:'none'}}>
      <div className="fs-name">Multireco Categories</div>
      <Move></Move>
      <div id="multireco-def-cats">
        <div className="def-cat replace-cat">Indifferent</div>
        <div className="def-cat replace-cat">Later</div>
        <div className="def-cat replace-cat">Stashed</div>
        <div className="def-cat add-txt" id="multireco-add-cat">;</div>
        <div className="def-cat add-txt" id="multireco-sub-cat">--</div>
        <div className="def-cat delete-cat" id="multireco-delete-cat">Delete</div>
      </div>
      <textarea className="fs-input single-line" id="multireco-input-cats" name="multireco-cats" placeholder="Category--Sub category--Subsub category ; Another category ; ..."></textarea>
      <div id="multireco-cat-fs-container" style={{display:'none'}}>
        <div id="multireco-cat-fs-list" className="fs-list"></div>
        <Exit onClick={() => {
          m.$multireco_cat_fs_container.hide();
        }}></Exit>
      </div>
      <Reset></Reset>
      <Exit onClick={() => m.$window.trigger({ type: 'keydown', code: 'KeyM' } as any)}></Exit>
    </div>
  );
}
